import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENExportType} from '../../enums';

export class PutExportProjectFormFields {

    public reasonForExport: FormField
    public exportType: FormField
    public project: FormField

    constructor() {

        this.reasonForExport = new FormField(
          'reasonForExport',
          'Reason for export',
          null,
          FormFieldType.text,
          false,
        )
        this.exportType = new FormField(
          'exportType',
          'Export type',
          null,
          FormFieldType.enumeration,
          false,
        )
        this.exportType.enumeration = ENExportType
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutExportProjectFormFields()

export const putExportProjectFormFieldOptions: {[key: string]: FormField} = {
  reasonForExport: fields.reasonForExport,
  exportType: fields.exportType,
  project: fields.project,
};